import React from "react";
import { useFormContext } from "react-hook-form";
import DateAndTimeGroup from "./forms/DateAndTimeGroup";
import ToggleComponent from "./forms/ToggleComponent";

const Reminder = () => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();
  const setReminder = watch("setReminder");

  return (
    <div className="pr-1">
      <ToggleComponent
        control={control}
        name="setReminder"
        label="Set a reminder to review"
        error={errors.setReminder}
      />
      {setReminder && (
        <DateAndTimeGroup
          dateName="reminderDate"
          timeName="reminderTime"
          control={control}
          dateFormat="YYYY-MM-DD"
          errorsDate={errors.reminderDate}
          errorsTime={errors.reminderTime}
        />
      )}
    </div>
  );
};

export default Reminder;
